import { DatePreset } from "./types";

export const DATE_PRESETS: readonly DatePreset[] = [
  { label: "Today", days: 0 },
  { label: "Yesterday", days: 1 },
  { label: "Last 3 days", days: 3 },
  { label: "Last 7 days", days: 7 },
  { label: "Last 14 days", days: 14 },
  { label: "Last 30 days", days: 30 },
  { label: "Last 90 days", days: 90 },
  { label: "Last year", days: 365 },
] as const;

export const FUTURE_DATE_PRESETS: readonly DatePreset[] = [
  { label: "Today", days: 0 },
  { label: "Tomorrow", days: 1 },
  { label: "Next 3 days", days: 3 },
  { label: "Next 7 days", days: 7 },
  { label: "Next 14 days", days: 14 },
  { label: "Next 30 days", days: 30 },
  { label: "Next 90 days", days: 90 },
] as const;
